module.exports = __webpack_public_path__ + "img/microsoft-logo.5909c075.svg";